import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, ModelDataService, UserService } from 'yt-ng-framework';
import { VrstaVozila } from './vrsta-vozila';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-vrsta-vozila',
  templateUrl: './vrsta-vozila.component.html'
})
export class VrstaVozilaComponent extends BaseModalContainer<VrstaVozila>
 implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaVozila>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService,
    protected modelDataService: ModelDataService
  ) { 
    super(modalContainerService
      , activatedRoute
      , modalService
      , userService
      , modelDataService
    )
  }

  ngOnInit() {
  }

}
